import { trigger, transition, style, animate, keyframes } from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
    transition(':enter', [
      animate(
        '300ms cubic-bezier(.25, 1, .30, 1)',
        keyframes([
          style({ clipPath: 'inset(0 0 100% 0)', offset: 0 }), // Start with full clipping
          style({ clipPath: 'inset(0 0 0 0)', offset: 1 }),    // End with no clipping
        ])
      ),
    ]),
  ]);

  export const wipeOutRight = trigger('wipeOutRight', [
    transition(':enter', [
      style({ clipPath: 'inset(0 0 100% 0 )' }),
      animate(
        '500ms cubic-bezier(0.25, 1, 0.3, 1)',
        style({ clipPath: 'inset(0 0 0 0)' })
      )
    ]),
    transition(':leave', [
      animate(
        '500ms cubic-bezier(0.25, 1, 0.3, 1)',
        style({ clipPath: 'inset(0 0 100% 0)' })
      )
    ])
  ]);
  
//   export const fadeInOut = trigger('fadeInOut', [
//     transition(':enter', [
//       animate(
//         '300ms cubic-bezier(.25, 1, .30, 1)',
//         keyframes([
//           style({ clipPath: 'inset(0 0 100% 0)', offset: 0 }), // Start with full clipping
//           style({ clipPath: 'inset(0 0 0 0)', offset: 1 }),    // End with no clipping
//         ])
//       ),
//     ]),
//   ]);

// export const fadeInOut = trigger('fadeInOut', [
//   transition(':enter', [
//     style({ opacity: 0 }),
//     animate('250ms', style({ opacity: 1 })),
//   ]),
//   transition(':leave', [
//     animate('250ms', style({ opacity: 0 })),
//   ]),
// ]);

// Add more animations as needed
